{
  "labels": {
    "naziv": "Nome",
    "naslov": "Indirizzo",
    "posta": "CAP",
    "kraj": "Città",
    "telefon": "Telefono",
    "email": "E-mail"
  },
  "buttons": {
    "vnesi": "Aggiungi voce"
  }
}